export default __webpack_public_path__ + "static/media/flag-united-states-of-america.0d34f81b.svg";